<template>
    <v-app id="lmra-web-portal" style="overflow: hidden;">
        <v-navigation-drawer
                v-model="drawer"
                app
                :clipped="$vuetify.breakpoint.mdAndUp"
                v-if="displayDrawer && is_online"
        >
            <v-list dense>
                <template v-for="item in drawer_items">
                    <v-row
                            v-if="item.heading"
                            :key="item.heading"
                            align="center"
                    >
                        <v-col cols="6">
                            <v-subheader v-if="item.heading">
                                {{ item.heading }}
                            </v-subheader>
                        </v-col>
                        <v-col
                                cols="6"
                                class="text-center"
                        >
                            <a
                                    href="#!"
                                    class="body-2 black--text"
                            >EDIT</a>
                        </v-col>
                    </v-row>
                    
                    <v-list-item
                            v-else
                            :key="item.text"
                            :to="item.link"
                            @click="closeDrawer"
                    >
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.text }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                
                </template>
                <v-list-item @click="logout()">
                        <v-list-item-action>
                            <v-icon>mdi-exit-to-app</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{$vuetify.lang.t('$vuetify.menu.log_out')}}
                            </v-list-item-title>
                        </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>


        <v-app-bar
                app
                :clipped-left="$vuetify.breakpoint.mdAndUp"
                color="secondary" dark>
            <v-app-bar-nav-icon v-if="displayDrawer" @click.stop="drawer = !drawer"/>
            <v-btn v-if="backBtnShown" text icon left color="white" class="navbackBtn" @click="backBtnPressed()">
                 <v-icon>{{ 'mdi-arrow-left' }}</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title class="app_title"> {{this.appSettings.applicationTitle}} </v-toolbar-title>
            <v-spacer></v-spacer>

            <template v-if="lang_change_allowed && supported_languages.length > 0">
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="white" v-on="on">
                        <span>{{$vuetify.lang.current}}</span>
                    </v-btn>
                </template>
                <v-list>
                    <template>
                    <v-list-item v-for="(item, index) in this.supported_languages" :key="'lang_'+index" @click="change_user_language(item.language)">
                        <v-list-item-title v-if="item.language !== $vuetify.lang.current">{{ item.language.toUpperCase() }}</v-list-item-title>
                    </v-list-item>
                    </template>
                </v-list>
            </v-menu>
            </template>
        </v-app-bar>

        <v-offline @detected-condition="handleConnectivityChange">
            <!-- SLOTS FOR ONLINE / OFFLINE -->
            <template slot="online">

                <template v-if="is_online">
                    <v-main>
                        <crit-err :shown="has_error" title="Application configuration error" :code="critErrCode">
                            {{$vuetify.lang.t('$vuetify.errors.app_corrupt')}}
                        </crit-err>

                        <!-- APPLICATION CONTENT GOES HERE -->
                        <transition name="ani-slide-in">
                        <router-view v-if="!has_error" :key="$route.fullPath">
                        </router-view>
                        </transition>
                        <!-- END OF APP -->
                        <sb-msg></sb-msg>
                    </v-main>
                </template>

                <template v-if="!is_online">
                <v-main>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <img class="mt-5 d-flex offline-image" src="./assets/no-internet.png">
                                <p class="text-center no-connection-text mt-4">{{$vuetify.lang.t('$vuetify.errors.no_internet')}}</p>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-main>
                </template>
            </template>
        </v-offline>
        <v-overlay :value="showAppLoader && is_online">
            <v-progress-circular color="cyan" indeterminate size="64"></v-progress-circular>
        </v-overlay>

      <resume-session-dialog :is-visible="(displayResumeWorkSessionDialog && $auth.isAuthenticated)"
      ></resume-session-dialog>
      <work-session-service-na-dialog :is-visible="(!$workSessions.loading && displayWorkSessionServiceNADialog && $auth.isAuthenticated)"
                                      :title="$vuetify.lang.t('$vuetify.workSessions.workSessionServiceNaDialog.title')"
                                      :body="$vuetify.lang.t('$vuetify.workSessions.workSessionServiceNaDialog.body')"

                                      @positive_btn_clicked="$workSessions.displayWorkSessionServiceNADialog = false"
      ></work-session-service-na-dialog>
      <sending-or-loading-data-comp :isSending="appSendingLMRADataLoader || appLoadingResourceData"></sending-or-loading-data-comp>
    </v-app>
</template>

<script>
    import VOffline from 'v-offline';
    import appSettings from "./mixins/config/appSettings";
    import { mobileCheckMixin } from "./mixins/MobileCheckMixin/MobileCheckMixin";
    import CriticalAppErrorComponent from './components/modules/global/criticalAppError/CriticalAppErrorComponent';
    import SnackbarMessgeComponent from './components/modules/global/snackbarMessage/SnackbarMessageComponent'
    import SendingOrLoadingDataOverlayComponent from "./components/modules/global/SendingOrLoadingDataOverlayComponent/SendingOrLoadingDataOverlayComponent";

    import {UserLanguageHelper} from "./helpers/userLanguage/UserLanguageHelper";
    import {DynamicQuestionListHelper} from "@/helpers/DynamicQuestionListHelper";
    import ResumeWorkSessionDialog from "@/components/workSessions/ResumeWorkSessionDialog";
    import SimplePopupComponent from "@/components/modules/global/simplePopup/SimplePopupComponent";



    export default {
        name: 'lmra-web-portal',
        components: {
            VOffline,
            critErr: CriticalAppErrorComponent,
            sendingOrLoadingDataComp: SendingOrLoadingDataOverlayComponent,
            sbMsg : SnackbarMessgeComponent,
            resumeSessionDialog : ResumeWorkSessionDialog,
            workSessionServiceNaDialog : SimplePopupComponent
        },
        data: () => ({
            drawer: false,
            critErrCode : 'UNKNOWN',
            has_error : false,
            is_online : navigator.onLine,
            hasBeenOffline : false,
            supported_languages : [],
            drawer_items: [
            ]
        }),
        methods: {
            handleConnectivityChange(status) {
                if(status){
                    if(this.hasBeenOffline){
                        this.hasBeenOffline = true;
                        window.location.reload();
                    }
                }else{
                    //console.log('YOU ARE OFFLINE');
                    this.hasBeenOffline = true;
                    this.is_online = status;
                }

            },
            logout(){
                this.$auth.logout();
            },
            backBtnPressed(){
                 this.$router.replace('/');
            },
            closeDrawer(){
                this.drawer = false;
            },
            build_menu(){
                this.drawer_items = [
                    {icon: 'mdi-view-headline', text: this.$vuetify.lang.t('$vuetify.menu.main_menu'), link : '/'},
                    {icon: 'mdi-format-list-checkbox', text: this.$vuetify.lang.t('$vuetify.menu.lmra'), link : 'lmra'},
                    {icon: 'mdi-alert', text: this.$vuetify.lang.t('$vuetify.menu.report_incident'), link : 'report_incident'},

                ];
                if(this.appSettings.usesNearIncidentReports) {
                    this.drawer_items.push({
                        icon: 'mdi-alert-octagon',
                        text: this.$vuetify.lang.t('$vuetify.menu.report_near_incident'),
                        link: 'report_near_incident'
                    });
                }
                if(this.appSettings.usesRiskAnalysis){
                    this.drawer_items.push({icon: 'mdi-clipboard-alert', text: this.$vuetify.lang.t('$vuetify.menu.risk_analysis'), link : 'risk_analysis'});
                }

                if(this.appSettings.usesCoronaRiskAnalysisVariant){
                    this.drawer_items.push({icon: 'mdi-biohazard', text: this.$vuetify.lang.t('$vuetify.menu.corona_analysis'), link : 'corona_analysis'});
                }


                if(this.appSettings.usesReportProcessIssue){
                    this.drawer_items.push({icon: 'mdi-disc-alert', text: this.$vuetify.lang.t('$vuetify.menu.process_issue'), link : 'process_issue'});
                }
                
                if(this.appSettings.usesQRCodeScanner){
                    this.drawer_items.push({icon: 'mdi-eye', text: this.$vuetify.lang.t('$vuetify.menu.scan_qr'), link : 'scan_qr'});
                }
                //ADD CHECKLIST AT LAST POSITION
                this.drawer_items.push( {icon: 'mdi-clipboard-text', text: this.$vuetify.lang.t('$vuetify.menu.checklist'), link : 'checklist'});
            },
            async change_user_language(new_lang){
                if(this.$vuetify.lang.locales[new_lang] !== undefined){
                    await UserLanguageHelper.setAndSaveUserLanguage(new_lang);
                    this.get_supported_languages();
                    if(this.$auth.isAuthenticated){
                      DynamicQuestionListHelper.getDynamicQuestions(true);
                    }

                }
            },
            get_supported_languages(){
                this.supported_languages = [];
                for(const lang in this.$vuetify.lang.locales){
                    if(lang !== this.$vuetify.lang.current){
                        this.supported_languages.push({'language' : lang});
                    }
                }
            }
        },
        mixins: [appSettings, mobileCheckMixin],
        computed:{
            backBtnShown(){
                if(!this.isOnTabletOrDesktop && this.$route.path !== '/'){
                    return true;
                }
                return false;
            },
            lang_change_allowed(){
                if(this.$route.path === '/'){
                    return true;
                }
                return false;
            },
            displayDrawer(){
                if(this.isOnTabletOrDesktop && this.$auth.isAuthenticated){
                    return true;
                }
                return false;
            },
            showAppLoader(){
                return this.$auth.loading || this.$workSessions.loading;
            },
            appSendingLMRADataLoader(){
                return this.$store.state.sendingLMRRAData;
            },
            displayResumeWorkSessionDialog(){
              return this.$workSessions.displayResumeSessionDialog;
            },
            displayWorkSessionServiceNADialog(){
              return this.$workSessions.displayWorkSessionServiceNADialog;
            },
            appLoadingResourceData(){
              return this.$store.state.loadingResourceData;
            }
        },
        mounted() {
            UserLanguageHelper.setAndSaveUserLanguage(UserLanguageHelper.getUserPreferredLanguage());
            this.get_supported_languages();
        },
        async created() {
            if(
                this.appSettings.applicationID === undefined ||
                this.appSettings.PLATFORM_BACKEND_BASE_URL === undefined ||
                this.appSettings.PLATFORM_BACKEND_API_VERSION === undefined
            ){
                this.has_error = true;
                this.critErrCode = 'CE-BC-01'
                return;
            }

            /*console.log(this.$vuetify.theme);*/
            if(this.$auth.isAuthenticated){
              await this.$auth.getUser();
              await this.$workSessions.performSessionCheck();
              DynamicQuestionListHelper.getDynamicQuestions(true);
            }
            //THIS DOES NOT USE THE AUTH MIXIN!!!
            this.build_menu();

            /*window.console.log(this.appSettings.applicationID)
            window.console.log('LINE -----')
            window.console.log(process.env.VUE_APP_CLIENT);
            window.console.log('END LINE -----')

            window.console.log('******* HOPPPAAAA ******')
            window.console.log();
            window.console.log('*****')*/
            //window.console.log(this.$store.getters.getUserId);
            //execute this when no session has been found ...
            //else load the projectSettings from the server...
            //END session...
            /*this.getLatestDynamicQuestions('en');
            this.getLatestDynamicQuestions(this.$vuetify.lang.current);
            this.get_supported_languages();*/

            //DOWNLOAD CLIENT LIST HERE ?


        }
    };


</script>
<style scoped lang="scss">
    .offline-image{
        margin: auto;
        width: 80%;
        max-width: 420px;
    }
        .no-connection-text{
            font-size: 14px;
            color: #999;
        }
</style>
<style lang="scss">
    .v-btn{
        &.h-50{
            min-height: 50px !important;
            margin-bottom: 15px;
        }
    }

    .ani-slide-in-leave-active,
    .ani-slide-in-enter-active {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        z-index: 1;
    }

    .ani-slide-in-enter-active{
        transition: all 1s ease;
    }
    .ani-slide-in-leave-active{
        transition: all .8s ease;
    }
    .ani-slide-in-enter {
       transform: translateX(100px);
        opacity: 0;
    }
    .ani-slide-in-leave-to {
        transform: translateX(-100px);
        opacity: 0;
    }

    .ani-fade-in-leave-active,
    .ani-fade-in-enter-active{
    }

    .ani-fade-in-enter-active{
        transition: all 0.5s ease-in;
    }

    .ani-fade-in-leave-active{
        transition: all .3s ease-out;
    }
    .ani-fade-in-enter,
    .ani-fade-in-leave-to {
        opacity: 0;
    }


</style>
